<template>
  <div id="app" v-title :data-title="$t('index.loginText')">
    <router-view v-if="isRouterAlive && !showMobile"/>
    <mobile-index v-if="showMobile"></mobile-index>
  </div>
</template>

<script>
import MobileIndex from '@/components/MobileIndex'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  components: {
    MobileIndex
  },
  data () {
    return {
      isRouterAlive: true,
      showMobile: false
    }
  },
  created () {
    var ua = navigator.userAgent
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/)
    var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/)
    var isAndroid = ua.match(/(Android)\s+([\d.]+)/)
    var isMobile = isIphone || isAndroid
    if (isMobile) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    reload: function () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
body,html
  height 100%
#app
  width 100%
  height 100%
  background-color #f5f5f5
</style>



// WEBPACK FOOTER //
// src/App.vue